import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import cx from 'classnames';
import { Dropdown, Button } from 'react-bootstrap';

import { colorToString, parseGradientColor } from 'components/Editor/helper/color';

import styles from './color.module.scss';
import { CustomInputFields } from '.';

const { Saturation, Hue, Alpha, EditableInput } = require('react-color/lib/components/common');
const GradientColorSettings = (props) => {
  const [rgb, setRgb] = useState(props.rgb)
  const [gradientConfig, setGradientConfig] = useState({
    colors: [
      { percent: 0, color: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})` },
      { percent: 100, color: 'rgba(138, 131, 124, 1)' }
    ],
    type: { label: 'Linear Gradient', value: 'Linear' },
    angle: 90,
    rgb: {r: rgb.r, g: rgb.g, b: rgb.b, a: rgb.a}
  })
  const [selectedColor, setSelectedColor] = useState(_.get(gradientConfig, 'colors[0]'));
  const [editMode, setEditMode] = useState(false);
  const gradientContainerStyle = getGradientColors(gradientConfig.colors);

  const handleColorPickerClick = (event) => {
    if (event.target.id == 'indicator') {
      return;
    }
    const colorPicker = event.target;
    const rect = colorPicker.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const percent = Math.round((x / colorPicker.offsetWidth) * 100);
      // Check if a color with the same percent already exists
    const existingColorIndex = gradientConfig.colors.findIndex((c) => c.percent === percent);

    if(existingColorIndex !== -1) {
      return;
    }
    const color = getColorAtPosition(percent);
    setGradientConfig((state) => {
      const newState = {
        ...state,
        colors: _.sortBy([...state.colors, { percent, color }], 'percent')
      }
      return newState;
    })
    setSelectedColor({ percent: percent, color: color })
  };

  useEffect(() => {
    let gradientStyle = null;

    switch (_.get(props, 'gradientType')) {
      case 'Linear':
        gradientStyle = { label: 'Linear Gradient', value: 'Linear' }
        break;

      case 'Radial':
        gradientStyle = { label: 'Radial Gradient', value: 'Radial' }
        break;

      case 'Angular':
        gradientStyle = { label: 'Angular Gradient', value: 'Angular' }
        break;
    }
    const firstColor = props.gradientColors && props.gradientColors[0];
    const parsedColor = firstColor && parseGradientColor(firstColor);
    setGradientConfig((state) => {
      const newState = {
        ...state,
        colors: setInitialColors(),
        type: gradientStyle ? gradientStyle : state.type,
        angle: props.degree ? props.degree : state.angle,
        rgb : parsedColor ? parsedColor : rgb
      }
      if (props.activeTab == 'gradient') {
        props.onConfirm(generateColorRequest(newState), props.activeTab);
      } else if (props.activeTab === 'solid') {
        const selectedRgb = selectedColor?.color;
        const rgbaMatch = selectedRgb?.match(/(\d+(\.\d+)?)/g);

        const parsedRgb = {
          r: parseInt(rgbaMatch[0]),
          g: parseInt(rgbaMatch[1]),
          b: parseInt(rgbaMatch[2]),
          a: parseFloat(rgbaMatch[3])
        };

        if (parsedRgb || parsedColor != 'undefined') {
          props.onConfirm({rgb : parsedRgb ? parsedRgb : parsedColor, type: 'solid'}, props.activeTab);
        }
        
      }
      return newState;
    })


  }, [props.activeTab])

  useEffect(() => {
    // Check if props.rgb is different from the state value
    if (!_.isEqual(props.rgb, rgb)) {
      setRgb(props.rgb)
      handleGradientColorChange(props.rgb)
    }
  }, [props.rgb])

  useEffect(()=>{
    // handleApplyColor()
  },[gradientConfig])

  const setInitialColors = () => {
    if (props.type == 'gradient' && props.gradientColors) {
      var existingColors = _.map(props.gradientColors, item => ({
        percent: item.position,
        color: `rgba(${item.r}, ${item.g}, ${item.b}, ${item.a})`
      }));

      return existingColors;
    }

    return gradientConfig.colors;
  }

  const handleSelectIndicator =(selected)=> {
    var gradientIndiColor = parseGradientColor(selected.color)
    var rgba = {
      r: gradientIndiColor.r,
      g: gradientIndiColor.g,
      b: gradientIndiColor.b,
      a: gradientIndiColor.a
    }
    props.onChange(rgba, props.activeTab)
    setSelectedColor(selected)
  }

  // mix the colors from the gradient color picker
  const mixColors = (color1, color2, ratio) => {
    const parseColor = (color) => {
      const match = color.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
      if (!match) return null;

      const [, r, g, b, a] = match.map(Number);
      return { r, g, b, a };
    };

    const getColorValue = (c1, c2, ratio) => Math.round(c1 + (c2 - c1) * ratio);

    const color1Obj = parseColor(color1);
    const color2Obj = parseColor(color2);

    if (!color1Obj || !color2Obj) return null;

    const r = getColorValue(color1Obj.r, color2Obj.r, ratio);
    const g = getColorValue(color1Obj.g, color2Obj.g, ratio);
    const b = getColorValue(color1Obj.b, color2Obj.b, ratio);

    return `rgba(${r}, ${g}, ${b}, 1)`;
  };

  // gets the color picker position using percent value
  const getColorAtPosition = (percent) => {
    const gradientValues = (gradientConfig.colors).map(stop => stop.color);

    const segmentWidth = 100 / (gradientValues.length - 1);
    const segmentIndex = Math.floor(percent / segmentWidth);
    const color1 = gradientValues[segmentIndex];
    const color2 = gradientValues[segmentIndex + 1];
    const positionInSegment = (percent % segmentWidth) / segmentWidth;

    return mixColors(color1, color2, positionInSegment);
  };

  const handleGradientColorChange = (colorRgb) => {
    if (!selectedColor) {
      return;
    }
  
    // Convert the color to string only once
    const newColor = colorToString(colorRgb);
    let colorChanged = false;
  
    let updatingGradient = gradientConfig?.colors?.map((color) => {
      if (color.percent === selectedColor?.percent && color.color !== newColor) {
        colorChanged = true;
  
        setSelectedColor((state) => ({
          ...state,
          color: newColor,
        }));
  
        return {
          ...color,
          color: newColor,
        };
      }
      return color;
    });
  
    if (colorChanged) {
      setGradientConfig((state) => {
        const newState = {
          ...state,
          colors: updatingGradient,
        };

        if (props.activeTab == 'gradient') {
          props.onConfirm(generateColorRequest(newState), props.activeTab);
        }
        return newState;
      });
    }
  };

  const handleDragStart = (event) => {
    const emptyImage = new Image();
    // to hide the drag snapshot of indicator
    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    event.dataTransfer.setDragImage(emptyImage, 0, 0);
  };

  const handleIndicatorDrag = (event, index) => {
    event.preventDefault();
    if (index == 0 || ((gradientConfig.colors).length - 1 == index)) {
      return
    }
    const colorPicker = event.target.closest('.color-picker');
    const rect = colorPicker.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const percent = (x / colorPicker.offsetWidth) * 100;

    if (percent >= 0 && percent <= 100) {
      var gradientColor = gradientConfig.colors
      const updatedIndicators = [...gradientColor];
      updatedIndicators[index].percent = percent;

      setGradientConfig((state) => {
        const newState = {
          ...state,
          colors: updatedIndicators
        }
        props.onConfirm(generateColorRequest(newState), props.activeTab);
        return newState;
      })
    }
  };

  useEffect(()=>{
    const currentActive = _.find(gradientConfig.colors, {'color': _.get(selectedColor, 'color')});
    if(!selectedColor) {
      return;
    }
    if( currentActive && (_.get(selectedColor, 'percent') !== currentActive.percent) ) {
      setSelectedColor((state)=>{
        return {
          ...state,
          percent: _.get(currentActive, 'percent')
        }
      })
    }
  },[gradientConfig.colors])

  const handleGradientAngle = (event) => {
    const regex = /^[0-9]*$/;
    if (!regex.test(event.target.value)) {
      return
    }
    const proccesed = parseAngleValue(event.target.value)
    setGradientConfig((state) => {
      const newState = {
        ...state,
        angle: proccesed
      }
      props.onConfirm(generateColorRequest(newState), props.activeTab); 
      return newState;
    })
  }

  const parseAngleValue = (value) => {
    if (!value) {
      return value
    }
    value = parseInt(value);
    if (value < 0) {
      value = 0;
    }
    value = Math.min(Math.max(value, 0), 360);
    return value;
  };


  const handleFlipGradients = () => {
    const gradientColor = gradientConfig.colors
    const reversedGradientColors = [...gradientColor].reverse();
    const newGradientColors = reversedGradientColors.map((color) => ({
      ...color,
      percent: Math.abs(color.percent - 100),
    }));

    setGradientConfig((state) => {
      const newState = {
        ...state,
        colors: newGradientColors
      }
      props.onConfirm(generateColorRequest(newState), props.activeTab);
      return newState;
    })
  };

  const handleDeleteColor = () => {
    const gradientColor = gradientConfig.colors
    if (_.size(gradientColor) == 2) {
      return
    }

    let updatedColors = _.filter(gradientColor, function (color) { return !_.isEqual(color, selectedColor) })
    setGradientConfig((state) => {
      return {
        ...state,
        colors: updatedColors
      }
    })
  }

  const handleGradientType = (type) => {
    if (type) {
      setGradientConfig((state) => {
        const newState = {
          ...state,
          type: type
        };
        props.onConfirm(generateColorRequest(newState), props.activeTab);
        return newState;
      })
    }
  }

  return (
    <>
      <div className={styles.gradientContainer}>
        <Dropdown className={styles.gradientDropdown}>
          <Dropdown.Toggle className={styles.selected}>
            {_.get(gradientConfig, 'type.label')}
          </Dropdown.Toggle>

          <Dropdown.Menu className={styles.gradientMenu}>
            <Dropdown.Item active={_.get(gradientConfig, 'type.value') == 'Linear'} onClick={() => handleGradientType({ label: 'Linear Gradient', value: 'Linear' })}>Linear Gradient</Dropdown.Item>
            <Dropdown.Item active={_.get(gradientConfig, 'type.value') == 'Radial'} onClick={() => handleGradientType({ label: 'Radial Gradient', value: 'Radial' })}>Radial Gradient</Dropdown.Item>
            <Dropdown.Item active={_.get(gradientConfig, 'type.value') == 'Angular'} onClick={() => handleGradientType({ label: 'Angular Gradient', value: 'Angular' })}>Angular Gradient</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <div className={cx(styles.gradientColorPicker, 'color-picker')} style={gradientContainerStyle} onClick={handleColorPickerClick}>
          {(_.get(gradientConfig, 'colors')).map((indicator, index) => {
            const activeState = _.isEqual(indicator.color, _.get(selectedColor, 'color', ''))
            return (
              <div
                key={index}
                id="indicator"
                draggable
                onDragStart={handleDragStart}
                onDrag={(event) => handleIndicatorDrag(event, index)}
                onDragEnd={()=>{setSelectedColor(indicator)}}
                onClick={() => { handleSelectIndicator(indicator) }}
                className={cx(styles.colorIndicator, { [styles.activeIndicator]: activeState })}
                style={{ left: `${indicator.percent}%`, backgroundColor: indicator.color }}
              >
                <div
                  className={styles.pointer}
                  style={{ borderTopColor: indicator.color }}
                />
                <div className={styles.pointerBorder} />
              </div>
            )
          })}
        </div>
        <div className={styles.gradientActionContainer}>
          <div className={cx(styles.angleContainer, { [styles.hideAngle]: _.get(gradientConfig, 'type.value') === 'Radial' })}>
            <span className={styles.text}>Angle</span>
            <input
              max={360}
              min={0}
              onChange={(e) => { handleGradientAngle(e) }}
              className={styles.inputValue}
              type='numeric'
              value={_.get(gradientConfig, 'angle')}
            />
          </div>
          <div className={styles.buttonContainer}>
            <Button variant='info' onClick={handleFlipGradients} className={styles.resetButton}>
              <i className={cx('cleverstory-horizontal', styles.flipIcon)} />
            </Button>
            <Button variant='info' disabled={_.size(gradientConfig.colors) == 2 || (_.get(selectedColor, 'percent') == 0 || _.get(selectedColor, 'percent') == 100)} onClick={handleDeleteColor} className={styles.deleteButton}>
              <i className={cx('cleverstory-trash', styles.trashIcon)} />
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.smallSaturationBox}>
        <Saturation
          {...props}
          onChange={(value) => 
            props.onChange(value, props.activeTab)
          }
          />
      </div>
      <div className={styles.colorSliderWrapper}>
        <div className={styles.sliderBox}>
          <div className={styles.hueSlider}>
            <Hue
              hsl={props.hsl}
              onChange={(value) => props.onChange(value, props.activeTab)}
              direction={'horizontal'}
            />
          </div>
          <div className={styles.alphaSlider}>
            <Alpha 
              {...props}
              onChange={(value) => props.onChange(value, props.activeTab)}
              direction={'horizontal'} 
            />          
          </div>
        </div>
        <div style={{ background: colorToString(props.rgb) }} className={styles.colorSwatch}></div>
      </div>
      <CustomInputFields {...props} activeTab={props.activeTab}/>
      {(!props?.brandkit || props.brandkit == undefined) &&
        <div className={styles.brandColorSwatches}>
          <div className={styles.actionContainer}>
            <span className={styles.colorSwatchTitle}>Brand Colors</span>
            <span onClick={() => setEditMode(!editMode)} className={styles.actionButton}>{editMode ? "Done" : "Edit"}</span>
          </div>
          <div className={styles.colorSwatchWrapper}>
            <Button onClick={props.handleAddColors} disabled={editMode} className={styles.addButton} variant='info'>
              <i className={cx('cleverstory-plus', styles.addIcon)} />
            </Button>
            <ColorSwatchs colors={props.brandColors} editMode={editMode} onChange={props.onChange} handleDelete={props.handleDelete} activeTab={props.activeTab}/>
          </div>
        </div>
      }
      <div className={styles.gloablColorDisplay}>
        <span className={styles.colorSwatchTitle}>Global Colors</span>
        <div className={styles.colorSwatchWrapper}>
          <ColorSwatchs colors={props.swatchColors} onChange={props.onChange} activeTab={props.activeTab}/>
        </div>
      </div>
      <div className={styles.buttonTray}>
      </div>
    </>
  );
}

const ColorSwatchs = ({ colors, editMode, onChange, handleDelete, activeTab }) => {
  return colors.map((color, index) => {
    return (
      <div key={index} className={cx(styles.colorBlock, { [styles.editMode]: editMode })}>
        <div
          onClick={() => {
            onChange(color, activeTab)
          }}
          key={color}
          className={cx(styles.colorSwatcher)}
          style={{ background: _.isObject(color) ? colorToString(color) : color }}
        />
        {editMode &&
          <Button onClick={() => handleDelete(color)} variant='info' className={styles.deleteOverlay}>
            <i className={cx('cleverstory-close')} />
          </Button>
        }
      </div>
    );
  })
}

const generateColorRequest = (gradientConfig) => {
  const request = {};
  request.type = 'gradient';
  request.gradientType = gradientConfig.type.value;
  request.degree = gradientConfig.angle;
  if (gradientConfig.colors.length > 0) {
    const firstColor = gradientConfig.colors[0].color;
    const parsedColor = parseGradientColor(firstColor);
    request.rgb = {
      r: parsedColor.r,
      g: parsedColor.g,
      b: parsedColor.b,
      a: parsedColor.a
    };
  }
  request.gradientColors = _.map(gradientConfig.colors, (item) => {
    const parsed = parseGradientColor(item.color);
    return {
      r: parsed.r,
      g: parsed.g,
      b: parsed.b,
      a: parsed.a,
      position: item.percent
    };
  });
  return request;
};

function getGradientColors(gradientColors) {

  const gradientString = _.map(_.sortBy(gradientColors, 'percent'), stop => `${stop.color} ${stop.percent}%`).join(', ');
  let gradientValue = { background: `linear-gradient(90deg, ${gradientString})` };

  return gradientValue;
}

export default GradientColorSettings;
